module.exports = __webpack_public_path__ + "static/media/platform.6c5d25af.svg";